module.exports = __webpack_public_path__ + "img/left_arrow.3aff1c6e.svg";